import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

RemoveRecordingDialog.propTypes = {
  recordingName: PropTypes.string,
  open: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default function RemoveRecordingDialog({ recordingName, open, onCancel, onConfirm }) {
  return (
    <Dialog open={!!open} onClose={onCancel}>
      <DialogTitle>Remove Recording</DialogTitle>
      <DialogContent>
        Are you sure you want to remove &quot;{recordingName}&quot;?
        All widgets linked to this recording will also be removed from all tabs.
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>Remove</Button>
      </DialogActions>
    </Dialog>
  );
}
